export default __webpack_public_path__ + "static/media/baby.f6f9a59b.svg";